export const normalizeUSState = (value) => {
  if (!value) return value;
  return value
    .replace(/[^a-zA-Z]/g, '')
    .slice(0, 2)
    .toUpperCase();
};

export const normalizeUpperCase = (value = '') => value.toUpperCase();
